// import 'core-js/actual';

var ready = (callback) => { 
  if(document.readyState != 'loading') callback;
  else document.addEventListener('DOMContentLoaded', callback);
}

// Preloader

preloader = document.getElementById('preloader');

window.addEventListener('load', () => {
  setTimeout(function() {
    preloader.classList.remove('active');
  }, 400);
});

window.addEventListener('beforeunload', (event) => {
  var activeEl = event.target.activeElement;

  var isMailto = activeEl && activeEl.protocol === 'mailto:';
  var isTel = activeEl && activeEl.protocol === 'tel:';

  if(!isMailto && !isTel) {
    preloader.classList.add('active');

    setTimeout(function() {
      preloader.classList.remove('active');
    }, 10000);
  }
});

window.addEventListener('pageshow', function(event) {
  if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
    if ( preloader ) {
      preloader.classList.remove('active');
    }
  }
});

// Navbar toggler

var didScroll;
var lastScrollTop = 0;
var delta = 40;
const navbar = document.querySelector(".navbar");
const pageWrapper = document.querySelector("#page");
var navbarHeight = navbar.offsetHeight;

var body = document.body,
    html = document.documentElement;

var docHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

window.onscroll = (event) => {
    didScroll = true;
};

setInterval( () => {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
    var st = window.pageYOffset;
    docHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

    // Make sure they scroll more than delta
    if( Math.abs( lastScrollTop - st ) <= delta )
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if( st > lastScrollTop && st > navbarHeight ) {
        // Scroll Down
        navbar.classList.add('nav-up');
        navbar.classList.remove('nav-down');
    } else {
        // Scroll Up
        if( st + window.innerHeight < docHeight ) {
            navbar.classList.add('nav-down');
            navbar.classList.remove('nav-up');
        }
    }

    lastScrollTop = st;
}

// Butiksfilter //

var setHeight = (el) => {
  var oldSize = parseInt(getComputedStyle(el).height);
  el.style.height = oldSize + "px";
}

const controlsWrapper = document.querySelector(".controls-wrapper");
const filterSelect = document.querySelector('.filter-select');
if(filterSelect) {
    const selElmnt = filterSelect.querySelector("select");
    
    const selSelected = document.querySelector(".select-selected");
    selSelected.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    filterSelect.appendChild(selSelected);
    
    const newSel = document.querySelector(".select-items");
    var j;
    for (j = 1; j < selElmnt.length; j++) {
        /* For each option in the original select element,
        create a new DIV that will act as an option item: */
        let selOption = document.createElement("DIV");
        selOption.innerHTML = selElmnt.options[j].innerHTML;
        selOption.addEventListener("click", function(e) {
            /* When an item is clicked, update the original select box,
            and the selected item: */
            var y, k, s, h, i;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            h = this.parentNode.previousSibling;
            for ( i = 0; i < s.length; i++ ) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    for (k = 0; k < y.length; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        newSel.appendChild(selOption);
    }
    filterSelect.appendChild(newSel);
    selSelected.addEventListener("click", function(e) {
        /* When the select box is clicked, close any other select boxes,
        and open/close the current select box: */
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
    });

    function closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, y, i, arrNo = [];
        x = document.querySelectorAll(".select-items");
        y = document.querySelectorAll(".select-selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }
    document.addEventListener("click", closeAllSelect);
}

let viewMode = "grid";

function resizeDiv(mode) {
    var oldSize = parseInt(getComputedStyle(document.querySelector(".response-wrapper")).height);
    let newSize;
    if (mode === "grid") {
      newSize = document.getElementById("response").scrollHeight;
    } else if (mode === "list") {
      newSize = document.querySelector(".letter-grid").scrollHeight;
    }
    document.querySelector(".response-wrapper").style.height = newSize + "px";
}

var serialize = (form) => {

	// Setup our serialized data
	var serialized = [];

	// Loop through each field in the form
	for ( var i = 0; i < form.elements.length; i++ ) {

		var field = form.elements[i];

		// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
		if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

		// If a multi-select, get all selections
		if (field.type === 'select-multiple') {
			for (var n = 0; n < field.options.length; n++) {
				if (!field.options[n].selected) continue;
				serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
			}
		}

		// Convert field data to a query string
		else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
			serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
		}
	}

	return serialized.join('&');
};

const filter = document.getElementById("filter");
if(filter) {
  let filterOption = document.querySelectorAll('.select-items div');
  const spinner = document.getElementById('filter-spinner');
  Array.from(filterOption).forEach( (el) => {
    el.addEventListener("click", function(event) {
      controlsWrapper.classList.add('disabled');
      let postData = serialize(filter);
      let curPosts = document.querySelectorAll('article');

      var url = filter.getAttribute('action');

      fetch(url, {
        method: filter.getAttribute('method'),
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        },
        body: postData
      })
      .then(res => res.text())
      .then(curPosts.forEach(x => x.classList.add('filter-fade')))
      .then(spinner.classList.add('loading'))
      .then(data => {
        spinner.classList.remove('loading')
        document.getElementById("response").innerHTML = data; // insert data
        resizeDiv(viewMode);

        const butiker = document.querySelectorAll('.butik');
        if ( butiker.length ) {
          butiker.forEach((x, i) => {
            gsap.fromTo(x, {
              y: 100,
              opacity: 0
            }, {
              y: 0,
              opacity: 1,
              duration: .7, 
              delay: 
                window.innerWidth > 991 ? .05 * (i % 4) :
                window.innerWidth < 992 && window.innerWidth > 599 ? .05 * (i % 3) :
                window.innerWidth < 600 && window.innerWidth > 359 ? .05 * (i % 2) : 0,
              scrollTrigger: x
            });
          })
        }

        setTimeout(() => {
          controlsWrapper.classList.remove('disabled');
        }, 850)
      })
      .catch(function (error) {
        console.log('Failed', error);
      });
    });
  });

  ready(() => {
    window.addEventListener('resize', () => {
      var responseHeight = document.getElementById("response").scrollHeight;
      document.querySelector(".response-wrapper").style.height = responseHeight + "px";
    });

    setHeight(document.querySelector(".response-wrapper"));
  });
}

const gridList = document.querySelector('.grid-list');
if(gridList) {
    const gridListBtn = document.querySelector('.grid-list-btn');
    const gridWrapper = document.querySelector('.grid-wrapper');
    const listWrapper = document.querySelector('.list-wrapper');
    const filterWrapper = document.querySelector('.filter-wrap');
    gridListBtn.addEventListener('click', (event) => {
        event.preventDefault();
        controlsWrapper.classList.add('disabled');
        gridList.classList.toggle('grid');
        gridWrapper.classList.toggle('hide');
        listWrapper.classList.toggle('show');
        if (viewMode === "grid") {
          viewMode = "list";
        } else if (viewMode === "list") {
          viewMode = "grid"
        }
        resizeDiv(viewMode);
        if(filterWrapper) {
            filterWrapper.classList.toggle('hide');
        }

        const butiker = document.querySelectorAll('.butik');
        if ( butiker.length ) {
          butiker.forEach((x, i) => {
            gsap.fromTo(x, {
              y: 100,
              opacity: 0
            }, {
              y: 0,
              opacity: 1,
              duration: .7, 
              delay: 
                window.innerWidth > 991 ? .05 * (i % 4) :
                window.innerWidth < 992 && window.innerWidth > 599 ? .05 * (i % 3) :
                window.innerWidth < 600 && window.innerWidth > 359 ? .05 * (i % 2) : 0,
              scrollTrigger: x
            });
          })
        }

        const letters = document.querySelectorAll('.letter-wrapper');
        if ( letters.length ) {
          letters.forEach((x, i) => {
            gsap.fromTo(x, {
              y: 100,
              opacity: 0
            }, {
              y: 0,
              opacity: 1,
              duration: .7, 
              delay: 
                window.innerWidth > 991 ? .05 * (i % 4) :
                window.innerWidth < 992 && window.innerWidth > 768 ? .05 * (i % 3) :
                window.innerWidth < 769 && window.innerWidth > 499 ? .05 * (i % 2) : 0,
              scrollTrigger: x
            });
          })
        }

        setTimeout(() => {
          controlsWrapper.classList.remove('disabled');
        }, 850)
    });
}

ready(() => {
  // Add vh variable to css
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px')

  window.addEventListener('resize', function() {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px')
  })

  // Toggle scrolling when menu open
  var menuToggle = document.querySelector('.menu-toggle');
  // var body = document.querySelector('body');
  var main = document.querySelector('#primary');
  var overlay = document.querySelector('.menu-open-overlay');
  var scrollPosition = 0;
  var isMenuOpen = false;

  function closeMenu() {
    isMenuOpen = false;
    body.classList.remove('menu-open');
    main.classList.remove('menu-open');
    overlay.classList.remove('visible');
    body.style.top = '';
    navbar.classList.add('closemenu');
    window.scrollTo(0, scrollPosition);
    setTimeout(() => {
      navbar.classList.add('nav-down');
      navbar.classList.remove('nav-up');
      navbar.classList.remove('closemenu');
    }, 300)
    overlay.removeEventListener('click', closeMenu)
  }

  menuToggle.addEventListener('click', function() {
    if (isMenuOpen) {
      closeMenu()
    } else {
      isMenuOpen = true;
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      body.classList.add('menu-open');
      main.classList.add('menu-open');
      overlay.classList.add('visible');
      body.style.top = -scrollPosition + 'px';
      overlay.addEventListener('click', closeMenu)
    }
  });
    
  // Butiker list mode
  var listItems = document.querySelectorAll('.list-item');
  listItems.forEach((i) => {
      let listName = i.textContent;
      let letter = listName.charAt(0);
      let parent = i.parentElement;
      
      if( parent.querySelectorAll('[data-letter="'+ letter +'"]').length < 1 ) {
          var elementDiv = document.createElement('div');
          var elementWrapper = document.createElement('div');
          var elementInner = document.createElement('div');
          var elementSpan = document.createElement('span');
          parent.appendChild(elementDiv);
          elementDiv.classList.add('letter-wrapper');
          elementDiv.appendChild(elementWrapper);
          elementWrapper.classList.add('letter');
          elementWrapper.appendChild(elementInner);
          elementInner.setAttribute('data-letter', letter);
          elementInner.classList.add('letter-inner');
          elementInner.appendChild(elementSpan);
          elementSpan.innerHTML = letter;
      }
      let letterParent = parent.querySelector('[data-letter="'+ letter +'"]');
      letterParent.append(i);
  });

  // Scroll reveal
  const srElements1 = document.querySelectorAll('.fade1');
  if ( srElements1.length ) {
    setTimeout(() => {
      srElements1.forEach((x, i) => {
        const delay = x.getAttribute("data-delay");
        gsap.fromTo(x, {
          y: 100,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: .6, 
          delay: delay ? delay : .1,
          scrollTrigger: x
        });
      })
    }, 400)
  }

  const srElements2 = document.querySelectorAll('.fade2');
  if ( srElements2.length ) {
    setTimeout(() => {
      srElements2.forEach((x, i) => {
        const delay = x.getAttribute("data-delay");
        gsap.fromTo(x, {
          y: 50,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: .5, 
          delay: delay ? delay : .1,
          scrollTrigger: x
        });
      })
    }, 400)
  }

  const srElements3 = document.querySelectorAll('.fade3');
  if ( srElements3.length ) {
    setTimeout(() => {
      srElements3.forEach((x, i) => {
        const delay = x.getAttribute("data-delay");
        gsap.fromTo(x, {
          opacity: 0
        }, {
          opacity: 1,
          duration: .5, 
          delay: delay ? delay : .1,
          scrollTrigger: x
        });
      })
    }, 400)
  }

  const newsPosts = document.querySelectorAll('.newsSwiper .swiper-slide-visible');
  if ( newsPosts.length ) {
    setTimeout(() => {
      newsPosts.forEach((x, i) => {
        gsap.fromTo(x, {
          y: 100,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: .6,
          delay: 
            window.innerWidth > 599 ? .1 * (i % 3) : .1 * (i % 2),
          scrollTrigger: x
        });
      })
    }, 400)
  }

  const instaPosts = document.querySelectorAll('.instapost-wrapper');
  if ( instaPosts.length ) {
    setTimeout(() => {
      instaPosts.forEach((x, i) => {
        gsap.fromTo(x, {
          y: 100,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: .6,
          delay: 
            window.innerWidth > 599 ? .1 * (i % 3) : .1 * (i % 2),
          scrollTrigger: x
        });
      })
    }, 400)
  }

  const butiker = document.querySelectorAll('.butik');
  if ( butiker.length ) {
    setTimeout(() => {
      butiker.forEach((x, i) => {
        gsap.fromTo(x, {
          y: 100,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: .7, 
          delay: 
            window.innerWidth > 991 ? .05 * (i % 4) :
            window.innerWidth < 992 && window.innerWidth > 599 ? .05 * (i % 3) :
            window.innerWidth < 600 && window.innerWidth > 359 ? .05 * (i % 2) : 0,
          scrollTrigger: {
            trigger: x,
            start: "top bottom+=80px"
          }
        });
      })
    }, 400)
  }
})